module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('li', [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-729ab3af", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-729ab3af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Option.vue
// module id = 133
// module chunks = 0